import { IsInSidePanelContext, SidePanelContext } from "components/SidePanel/SidePanelContext";
import { useContext } from "react";
import { useViewport } from "utilities/hookutils";
import { isViewport } from "utilities/viewportUtils";

export type PurpleHeaderLayout = "short" | "wide";

export const usePurpleHeaderLayout = (): PurpleHeaderLayout => {
  const isInSidePanel = useContext(IsInSidePanelContext);
  const { layoutType } = useContext(SidePanelContext);
  const viewport = useViewport();

  if (isInSidePanel) {
    return layoutType === "wide" ? "wide" : "short";
  }

  return isViewport(viewport).biggerThan("desktopSmall")
    ? "wide"
    : "short";
};
